export const cart = state => {
  return state.cart;
};
export const items = state => {
  return state.items;
};
export const colors = state => {
  return state.colors;
};
export const selectedColor = state => {
  return (state.selectedColor) ? state.selectedColor : {id: 2, name: '黒', color: '#000000', color_type: {price_factor: 1.0}};
};
